import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Typography, Icon, Divider, IconButton, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { format, parseISO } from 'date-fns'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'

import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import leaveRequestStatusHandler from 'module/leave/util/leaveRequestStatusHandler'
import AdxButton from 'components/custom/AdxButton'

const LeaveRequestCardList = ({ item, index, lastIndex }) => {
  let location = useLocation()
  let navigate = useNavigate()
  let theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <>
      <Box
        onClick={() =>
          navigate(`/app/leave/request/${item.id}`, {
            state: {
              backgroundLocation: location,
            },
          })
        }
        sx={{
          width: '100%',
          minHeight: '100px',
          p: 2.5,
          display: 'flex',
          alignItems: 'center',
          columnGap: { xs: 1, sm: 3 },
          boxSizing: 'border-box',
          '&:hover': {
            cursor: 'pointer',
          },
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', lg: 'center' },
            columnGap: 2,
            rowGap: 1,
          }}
        >
          <Box>
            <Typography variant="subtitle1">{item?.leave_policy_name}</Typography>
            <Box
              sx={{
                display: 'flex',
                alignItems: { xs: 'flex-start', lg: 'center' },
                flexDirection: { xs: 'column', lg: 'row' },
                columnGap: 1,
              }}
            >
              <Typography variant="subtitle2" color="alternate.main">
                {item?.duration === 1 ? `${item?.duration} day` : `${item?.duration} days`}
              </Typography>
              {matches ? (
                <Icon sx={{ fontSize: 7, color: 'light-gray-text.main' }}>circle</Icon>
              ) : null}
              <Typography
                sx={{ display: { xs: 'none', sm: 'block' } }}
                color="light-gray-text.main"
                variant="subtitle2"
              >
                {item?.start_date &&
                  item?.end_date &&
                  ` ${format(parseISO(item?.start_date), 'dd/MM/yyyy')} - 
                ${format(parseISO(item?.end_date), 'dd/MM/yyyy')}`}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            columnGap: 1,
          }}
        >
          <AdxStatusBar status={leaveRequestStatusHandler(item.status)} />
          <ChevronRightRoundedIcon />
        </Box>
      </Box>
      {lastIndex === index ? null : <Divider light />}
    </>
  )
}

export default LeaveRequestCardList
